module.exports = __webpack_public_path__ + "static/img/air1 (1).5c5a47b2.jpg";